module.exports = {
  footerText: '© X-Matic GmbH 2023',
}
